const state = {
  avenant  : { page : 1, perPage : 10 },
  client   : { page : 1, perPage : 10 },
  company  : { page : 1, perPage : 10 },
  mandate  : { page : 1, perPage : 10 },
  offer    : { page : 1, perPage : 10 },
  property : { page : 1, perPage : 10 },
  request  : { page : 1, perPage : 10 },
  thread   : { page : 1, perPage : 10 }
};

const getters = {
  avenantPagination  : state => state.avenant,
  clientPagination   : state => state.client,
  companyPagination  : state => state.company,
  mandatePagination  : state => state.mandate,
  offerPagination    : state => state.offer,
  propertyPagination : state => state.property,
  requestPagination  : state => state.request,
  threadPagination   : state => state.thread
};

const mutations = {
  SET_PAGINATION : (state, { model, pagination }) => {

    state[model] = pagination;
  }
};

const actions = {
  updatePagination({ commit }, { model, pagination }) {

    commit('SET_PAGINATION', { model, pagination });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
